/* Sunnafrucht Kassen-Pop-up, Teil 1: Daten und Vorschlagslogik (16.10.2026).
   Regeln im Theme-Editor: Footer > Kassen-Pop-up. Bestseller kommen live aus
   /collections/<handle>?sort_by=best-selling&section_id=sf-kassen-feed */
(function () {
  'use strict';
  if (window.SFKP && window.SFKP.fn) return;
  var SFKP = window.SFKP = { feeds: {}, st: {}, root: null, origin: null, passing: false, busy: false, hideTimer: 0 };
  var R = SFKP.R = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var KEY = 'sfkp_seen_v1';

  function cfg() {
    var el = document.getElementById('sfkp-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function rate() {
    var r = window.Shopify && window.Shopify.currency ? Number(window.Shopify.currency.rate) : 1;
    return r > 0 ? r : 1;
  }
  function design() { return !!(window.Shopify && window.Shopify.designMode); }
  function seen() { try { return window.sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function markSeen() { try { window.sessionStorage.setItem(KEY, '1'); } catch (e) {} }
  function decode(s) { var t = document.createElement('textarea'); t.innerHTML = String(s); return t.value; }
  function plain(s) { var d = document.createElement('div'); d.innerHTML = String(s); return d.textContent || ''; }
  function dl(c, p, t, d) {
    var n = (c / 100).toFixed(p).split('.');
    return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (n[1] ? d + n[1] : '');
  }
  function fmt(cents) {
    cents = Number(cents) || 0;
    var f = window.KROWN && window.KROWN.settings && window.KROWN.settings.shop_money_format;
    var m = f ? String(f).match(/\{\{\s*(\w+)\s*\}\}/) : null;
    if (m) {
      var v = '';
      if (m[1] === 'amount') v = dl(cents, 2, ',', '.');
      else if (m[1] === 'amount_no_decimals') v = dl(cents, 0, ',', '.');
      else if (m[1] === 'amount_with_comma_separator') v = dl(cents, 2, '.', ',');
      else if (m[1] === 'amount_no_decimals_with_comma_separator') v = dl(cents, 0, '.', ',');
      else if (m[1] === 'amount_no_decimals_with_space_separator') v = dl(cents, 0, ' ', '.');
      else if (m[1] === 'amount_with_apostrophe_separator') v = dl(cents, 2, "'", '.');
      if (v) return decode(String(f).replace(m[0], function () { return v; }).replace(/<[^>]*>/g, ''));
    }
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var n = cents / 100;
    if (cur === 'CHF') return 'CHF ' + n.toFixed(2);
    try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: cur }).format(n); } catch (e) { return n.toFixed(2) + ' ' + cur; }
  }
  function getCart() {
    return fetch(R + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
  }
  function feed(h) {
    var F = SFKP.feeds;
    if (!F[h]) {
      F[h] = fetch(R + 'collections/' + encodeURIComponent(h) + '?sort_by=best-selling&section_id=sf-kassen-feed', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('feed'); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var s = doc.querySelector('script[data-sfkp-feed]');
          var list = s ? JSON.parse(s.textContent) : [];
          return Array.isArray(list) ? list : [];
        })
        .catch(function () { delete F[h]; return []; });
    }
    return F[h];
  }
  function typesOk(p, types) {
    var list = String(types || '').split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
    return !list.length || list.indexOf(String(p.type || '').toLowerCase()) > -1;
  }
  function parts(title) {
    var seg = String(title || '').split(' | ').map(function (s) { return s.trim(); }).filter(Boolean);
    var out = { name: seg[0] || String(title || ''), weight: '', desc: '' };
    if (seg.length > 1) {
      var last = seg[seg.length - 1];
      if (/^\d+([.,]\d+)?\s?(g|kg|ml|l)$/i.test(last) || /kapseln/i.test(last)) { out.weight = last; seg.pop(); }
      if (seg.length > 1) out.desc = seg.slice(1).join(' · ');
    }
    return out;
  }
  function plan(c, cart, forced) {
    var inCart = {};
    (cart.items || []).forEach(function (i) { inCart[i.product_id] = true; });
    var chain = (c.rules || []).filter(function (r) {
      if (forced) return r.id === forced;
      return (r.trigger || []).some(function (id) { return inCart[id]; });
    });
    if (c.fallback && c.fallback.targets && c.fallback.targets.length) chain.push(c.fallback);
    return { chain: chain, inCart: inCart };
  }
  function choose(c, pl, lists) {
    var max = Number(c.max) || 3;
    var cap = c.maxPrice ? Math.round(c.maxPrice * rate()) : 0;
    var out = [], taken = {}, head = null;
    pl.chain.forEach(function (rule, ri) {
      if (out.length >= max) return;
      var before = out.length;
      var queues = (rule.targets || []).map(function (t, ti) {
        return ((lists[ri] || [])[ti] || []).filter(function (p) {
          return p && p.a === true && !pl.inCart[p.id] && (!cap || p.p <= cap) && typesOk(p, t.types);
        });
      });
      var moved = true;
      while (out.length < max && moved) {
        moved = false;
        for (var q = 0; q < queues.length && out.length < max; q++) {
          while (queues[q].length) {
            var p = queues[q].shift();
            if (!taken[p.id]) { taken[p.id] = true; out.push(p); moved = true; break; }
          }
        }
      }
      if (!head && out.length > before) head = rule;
    });
    return { items: out, head: head };
  }
  function resolve(c, forced) {
    return getCart().then(function (cart) {
      if (!forced && !cart.item_count) return null;
      var pl = plan(c, cart, forced);
      return Promise.all(pl.chain.map(function (r) {
        return Promise.all((r.targets || []).map(function (t) { return feed(t.h); }));
      })).then(function (lists) {
        var res = choose(c, pl, lists);
        res.cart = cart;
        return res.items.length ? res : null;
      });
    });
  }

  SFKP.fn = { cfg: cfg, rate: rate, design: design, seen: seen, markSeen: markSeen, plain: plain, fmt: fmt, getCart: getCart, feed: feed, typesOk: typesOk, parts: parts, plan: plan, choose: choose, resolve: resolve };
})();